import {getNumberFromInput} from '../../../record-editing';
import {
    LabelContainer,
    Label,
    ValidationsList,
    NumberControlShowingEdits,
    FormFieldContainer
} from '../../../components/Form/FormStyles';
import {ValidateControl} from '../../../components/Controls/ValidateControl';
import {EditedProject} from '../EditedProject';
import styled from 'styled-components';

export const NumericFormFieldContainer = styled(FormFieldContainer)`
    & > input {
        max-width: 200px;
    }
`;

export function NumberOfCommunityVolunteers({
    project,
    setProjectAndValidate
}: {
    project: EditedProject;
    setProjectAndValidate: (project: EditedProject) => void;
}) {
    return (
        <NumericFormFieldContainer>
            <LabelContainer>
                {!project.ControlledByAutomation && (
                    <ValidateControl
                        validated={project.CommunityNumberOfTotalParticipantsValidated.current}
                        disabled={project.CommunityNumberOfTotalParticipants.notValidToShowPartner}
                        onChange={(e) =>
                            setProjectAndValidate({
                                ...project,
                                CommunityNumberOfTotalParticipantsValidated:
                                    project.CommunityNumberOfTotalParticipantsValidated.update(
                                        e.validated
                                    )
                            })
                        }
                    />
                )}
                <Label htmlFor="numberOfCommunityVolunteers">Total number of participants</Label>
            </LabelContainer>
            <NumberControlShowingEdits
                id="numberOfCommunityVolunteers"
                disabled={project.ControlledByAutomation}
                value={project.CommunityNumberOfTotalParticipants}
                onChange={(e) =>
                    setProjectAndValidate({
                        ...project,
                        CommunityNumberOfTotalParticipants:
                            project.CommunityNumberOfTotalParticipants.update(getNumberFromInput(e))
                    })
                }></NumberControlShowingEdits>
            <ValidationsList validations={project.CommunityNumberOfTotalParticipants.validations} />
        </NumericFormFieldContainer>
    );
}
